import i18n from '@/plugins/i18n/config.js'
import { displayToast } from '@/utils/toastUtils'

export const downloadFiles = async (fileUrl, filename = null) => {
  let blobUrl = null

  if (typeof fileUrl === 'string') {
    blobUrl = fileUrl
  } else if (fileUrl instanceof Blob) {
    blobUrl = URL.createObjectURL(fileUrl)
  } else {
    displayToast(i18n.global.t('INVALID_FILE_GENERATED_KEY'), 'error')
  }

  if (blobUrl) {
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = blobUrl

    if (filename) {
      a.setAttribute('download', filename)
    }

    document.body.appendChild(a)
    a.click()

    await new Promise((resolve) => setTimeout(resolve, 500))
    document.body.removeChild(a)
  }
}

export function getEmailPattern() {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9._+-]+\.[a-zA-Z]{2,7}$/
}

export function capitalizeFirstLetter(string) {
  const lowerCaseString = string.toLowerCase()

  return lowerCaseString.charAt(0).toUpperCase() + lowerCaseString.slice(1)
}

export function hasDisplayValue(value) {
  if (value === null || value === undefined) {
    return false
  }

  if (typeof value === 'string') {
    return value.trim() !== ''
  }

  return true
}

export function displayValueOrNoValue(value) {
  return hasDisplayValue(value) ? value : i18n.global.t('COMMON.NO_VALUE')
}

export function formatPhoneNumber(value) {
  if (!hasDisplayValue(value)) {
    return displayValueOrNoValue(value)
  }

  const phoneNumber = String(value)
  const digits = phoneNumber.replace(/\D/g, '')

  if (digits.length === 10) {
    return digits.match(/.{1,2}/g).join(' ')
  }

  if (digits.length === 11 && digits.startsWith('33')) {
    return `+33 ${digits.slice(2, 3)} ${digits
      .slice(3)
      .match(/.{1,2}/g)
      .join(' ')}`
  }

  return displayValueOrNoValue(value)
}

export const formatRegionCodeTitle = (string) => {
  const lowercaseString = string.toLowerCase()
  const trimmedString = lowercaseString.trim()
  const normalizedString = trimmedString.replace(/\s*-\s*/g, '-').replace(/\s+/g, ' ')

  return normalizedString.replace(/(?:^|\s)(\p{Ll})/gu, function (match) {
    return match.toUpperCase()
  })
}
